<template>
  <overdrive id="element">
    <div class="rectangle"></div>
  </overdrive>
</template>

<script>
export default {
  name: 'el-rectangle'
}
</script>

<style scoped>
  .rectangle {
    background: green;
    width: 300px;
    height: 150px;
    position: absolute;
    margin: auto;
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/Rectangle.vue